import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { LinkPagesRepoService } from '@client/app/services/api/link-pages-repo/link-pages-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { CheckForDuplicatesService } from '@client/app/core/services/check-for-duplicates/check-for-duplicates.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: '\n                                     tabindex="0"\n                                     role="button"link-content',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header
                    [header]="header"
                    panelClass="row"
                    panelLeftClass="col-32 col-md-28 col-lg-30 position-static"
                    panelRightClass="col-16 col-md-20 col-lg-18"
                    [subHeader]="subHeader">
                <page-header-content>
                    <div class="d-flex mon-dialog-delay-fadein">
                        <div class="p-1 mr-1">
                            <a *ngIf="'table_filters' | activeFeature"
                               (click)="isFiltersOpen = !isFiltersOpen"
                               class="text-link inline-block outer-t-small cursor-pointer">
                                <span class="fas fa-filter fa-lg" aria-hidden="true"></span>
                                <span class="sr-only" translate>Filter</span>
                            </a>
                        </div>

                        <div class="p-1">
                            <csv-export-button [exports]="exports"
                                               clsSize="py-2 px-3"
                                               clsMargin="mr-0">
                            </csv-export-button>
                        </div>

                        <div class="col-38 col-md-43 col-lg-43 inner-r-large mt-1">
                            <table-search [minSearchLength]="3"
                                          class="block outer-r-small"
                                          theme="grey-theme"
                                          [placeholderTxt]="'Search...' | translate"
                                          [(model)]="search"
                                          (getPage)="onSearch($event)">
                            </table-search>
                        </div>
                    </div>
                </page-header-content>
            </page-header>
        </div>

        <div class="mon-dialog-body">
            <div class="card panel-monsido-card outer-t outer-r outer-l">
                <div class="card-body">
                    <div class="row">
                        <div class="col-48" [class.merge-t-16]="isFiltersOpen">
                            <table-filters [(open)]="isFiltersOpen"
                                           [(ngModel)]="filters"
                                           [filters]="availableFilters"
                                           *ngIf="'table_filters' | activeFeature"
                                           name="filtersModel"
                                           (onChanges)="onFiltersChanged($event)">
                            </table-filters>
                        </div>
                    </div>
                    <mon-tabs
                            [options]="tabs"
                            (onSearch)="onSearch($event)"
                            [search]="search"
                            [minSearchLength]="1">
                    </mon-tabs>
                    <table-container [collection]="pages"
                                     (onPageChange)="onPageChange($event)"
                                     (onPerPageChange)="onPageSizeChange($event)"
                                     class="pages-table-wrapper"
                                     [progress]="progress"
                    >
                        <table class="table table-hover table-fixed table-with-labels">
                            <thead>
                            <tr>
                                <th monTableSort
                                    [monSortBy]="'title'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{ 'Title' | translate }}
                                </th>
                                <th class="col-sm-4 col-md-4 col-lg-3" *ngIf="showUnwantedViolations" translate>Unwanted violations</th>
                                <th class="col-sm-4 col-md-4 col-lg-3" *ngIf="showNormalViolations" translate>Normal violations</th>
                                <th class="col-6"
                                    monTableSort
                                    [monSortBy]="'priority_score'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{ 'Priority' | translate }}
                                </th>
                                <th class="col-6"
                                    monTableSort
                                    [monSortBy]="'hits'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    *ngIf="viewsColumIsAvailable">
                                    {{ 'Views' | translate }}
                                </th>
                                <th class="col-9">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let page of pages">
                                <td>
                                    <div class="text-ellipsis">
                                        <mon-url-title
                                                *ngIf="!pageDetailsIsAvailable"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </mon-url-title>
                                        <url-title-page-details
                                                *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                                [target]="'page-details-section-qa'"
                                                [subTarget]="subTarget"
                                                (onClose)="onPageDetailsClose()"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [page]="page"
                                                [active]="false" >
                                        </url-title-page-details>
                                        <url-title-document-details *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                                    [document]="page"
                                                                    [title]="page.title"
                                                                    [url]="page.url"
                                                                    [active]="true"
                                                                    [target]="'qa'"
                                                                    [subTarget]="policy">
                                        </url-title-document-details>
                                    </div>
                                    <label-table *ngIf="showLabels"
                                                 [assignedLabels]="page.labels"
                                                 (getLabels)="getLabels()"
                                                 [existingLabels]="labels"
                                                 (onUpdateLabel)="updateLabels(page)">
                                    </label-table>
                                </td>
                                <td *ngIf="showUnwantedViolations">
                                    <icon-button
                                            faIcon="fa-gavel"
                                            [number]="page.error_searches_count"
                                            positive="text-info"
                                            neutral="text-neutral-misspelling"
                                            [monAriaIconText]="'Unwanted violations' | translate"
                                            [changeTextColor]="false">
                                    </icon-button>
                                </td>
                                <td *ngIf="showNormalViolations">
                                    <icon-button
                                            faIcon="fas fa-bug"
                                            [number]="(page.searches_count - page.error_searches_count)"
                                            positive="text-danger"
                                            negative="negative"
                                            neutral="text-neutral-misspelling"
                                            [monAriaIconText]="'Violations' | translate"
                                            [changeTextColor]="false">
                                    </icon-button>
                                </td>
                                <td class="text-v-middle">
                                    <mon-priority class="vcenter" [priority]="page.priority_score_as_text"></mon-priority>
                                </td>
                                <td *ngIf="viewsColumIsAvailable" class="text-v-middle">
                                    <visits [title]="page.title" [visits]="page.hits" [totalVisits]="pages.pageHits"></visits>
                                </td>
                                <td class="text-v-middle">
                                    <div class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap">
                                        <table-page-details
                                                *ngIf="page.type === 'html'"
                                                [ngbTooltip]="'Open page details' | translate"
                                                [triggers]="'focus hover'"
                                                [target]="'page-details-section-qa'"
                                                [subTarget]="subTarget"
                                                [page]="page">
                                        </table-page-details>
                                        <table-document-details
                                                *ngIf="page.type !== 'html'"
                                                [ngbTooltip]="'Open Document Details' | translate"
                                                [triggers]="'focus hover'"
                                                target="qa"
                                                [subTarget]="policy"
                                                [document]="page"
                                                (callBack)="onPageDetailsClose()">
                                        </table-document-details>
                                        <mon-extension-visual-link-button class="ml-1" [page]="page" [type]="extensionType"></mon-extension-visual-link-button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class LinkContentComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() link: any;
    @Input() type: string = 'html';

    // Properties from extended controllers and component logic
    pages: any = [];
    tabs: any[] = [];
    extensionType: string = '';
    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    header: string = '';
    subTarget: string = '';
    policy: string = '';
    subHeader: string = '';
    exports: any[] = [];
    progress: any;
    eventId: any = '';
    showUnwantedViolations: boolean = false;
    showNormalViolations: boolean = false;

    constructor (
        private linkPagesRepoService: LinkPagesRepoService,
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private baseEntityService: BaseEntityService,
        private checkForDuplicatesService: CheckForDuplicatesService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.eventId = this.monEventService.addListener(
            ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );

        this.pages = [];
        this.tabs = [];
        this.type = this.type || 'html';
        this.search = '';
        this.isFiltersOpen = false;
        this.currentSort = { by: 'title', direction: 'desc' };
        this.extensionType = '';
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');

        if (this.type === 'document' && this.link.type !== 'image') {
            this.header = this.translateService.getString('Documents with Broken Link');
        } else if (this.type === 'document' && this.link.type === 'image') {
            this.header = this.translateService.getString('Documents with Broken Image');
        } else if (this.link.type !== 'image') {
            this.header = this.translateService.getString('Content with Broken Link');
        } else {
            this.header = this.translateService.getString('Content with Broken Image');
        }

        if (this.link.type !== 'image') {
            this.extensionType = 'blnk';
        } else {
            this.extensionType = 'bimg';
        }

        this.subTarget = this.link.type !== 'image' ? 'brokenlinks' : 'brokenimages';
        this.getPage();
        this.subHeader = '<a href="' + this.link.url + '" target="_blank" aria-describedby="linkOpensInNewTab">' + this.link.url + '</a>';
        this.getLabels();

        this.exports = [
            {
                data: {
                    category: 'pages_with_specific_link',
                    category_ref: this.link.id,
                },
            },
        ];
    }

    ngOnDestroy (): void {
        this.monEventService.remove(this.eventId);
    }

    override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            link_id: this.link.id,
            'types[]': ['html'],
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.type === 'document') {
            params['types[]'] = ['document', 'pdf'];
        }

        if (this.type === 'all') {
            params['types[]'] = undefined;
        }

        if (this.search && this.search !== '') {
            params.search = this.search;
        }

        const updatedParams = this.updateParamsWithFilters(params);

        this.progress = this.linkPagesRepoService.get(updatedParams).then((data: any) => {
            this.checkForDuplicatesService.checkForDuplicatePages(data);
            this.pages = data;
        }, () => {});
    }

    onFiltersChanged (changes: any): void {
        this.updateFilters(changes);
        this.getPage();
    }

    onSearchChanged (search: string): void {
        this.search = search;
        this.getPage();
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

}
